import PricePerTime from './PricePerTime.js';

export default class ClubBookedSalesListOfferingItem {
    static fromData(data) {
        if (!data) {
            return;
        }

        const bookedSalesListOfferingItem = new ClubBookedSalesListOfferingItem();
        bookedSalesListOfferingItem.memberClubFeeId = data.memberClubFeeId;
        bookedSalesListOfferingItem.clubFeeId = data.clubFeeId;
        bookedSalesListOfferingItem.clubFeeName = data.clubFeeName;
        bookedSalesListOfferingItem.numerator = data.numerator;
        bookedSalesListOfferingItem.denominator = data.denominator;
        bookedSalesListOfferingItem.pricePerTime = PricePerTime.fromData(data.pricePerTime.data);
        bookedSalesListOfferingItem.isBilled = data.isBilled;
        bookedSalesListOfferingItem.isAvailable = data.isAvailable;

        return bookedSalesListOfferingItem;
    }
}
